import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { IConnectedPage } from '../../../../types/api/connectedPages/IConnectedPage';

const deletePageAndChildPagesFromSearchParams = (
  page: IConnectedPage,
  searchParams: URLSearchParams,
) => {
  searchParams.delete('pages', page.pageId);
  page.childPages?.forEach(p => deletePageAndChildPagesFromSearchParams(p, searchParams));
};

export function useConnectedPagesExpandHandler(
  page: IConnectedPage,
) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [isActive, setIsActive] = useState<boolean>(searchParams.has('pages', page.pageId));

  useEffect(() => {
    setIsActive(searchParams.has('pages', page.pageId));
  }, [page.pageId, searchParams]);

  const onExpandedButtonClick = () => {
    setSearchParams((prevSearchParams) => {
      if (isActive) {
        deletePageAndChildPagesFromSearchParams(page, prevSearchParams);
      } else if (!prevSearchParams.has('pages', page.pageId)) {
        prevSearchParams.append('pages', page.pageId);
      }

      return new URLSearchParams([...prevSearchParams]);
    }, { state: { refetch: 'ignoreQuery' } });
  };

  return { onExpandedButtonClick, isActive };
}
